import { IWebsiteBuilderWebsiteVersionNavigationMenuDropdownItem } from "redux/reducers/models/websiteBuilder";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { useState } from "react";
import Input from "components/form/input/Input";
import { ButtonNew as Button } from "components/buttonNew";
import "./renameDropdownView.scss";
import { WebsiteBuilderToolbarMenuView } from "../../../WebsiteBuilderToolbarMenuView";
import { websiteBuilderUpdateNavigationMenuItem } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";

interface IRenameDropdownViewProps {
  item: IWebsiteBuilderWebsiteVersionNavigationMenuDropdownItem;
  disabled: boolean;
  goBackToParentView: () => void;
}

export function RenameDropdownView(props: IRenameDropdownViewProps) {
  const { item, disabled, goBackToParentView } = props;

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const navigationMenuItems = useAppSelector(store => store.websiteBuilderStore.editor.navigationMenuItems);

  const [updatedLabel, setUpdatedLabel] = useState<string>(item.label);

  const updatedLabelValid = updatedLabel?.length > 0;

  const renameDropdownEnabled = !disabled && updatedLabelValid;

  function renderRenameDropdownUpdateSection() {
    return (
      <Input
        label={t("Dropdown name")}
        value={updatedLabel}
        error={!updatedLabelValid}
        onChange={e => setUpdatedLabel(e.target.value)}
      />
    );
  }

  function renameDropdown() {
    void dispatch(websiteBuilderUpdateNavigationMenuItem({
      id: item.id,
      page_id: null,
      type: item.type,
      label: updatedLabel,
      external_url: null,
      open_in_new_tab: false,
      position: item.position,
      parent_id: null,
      hidden: item.hidden,
    }, navigationMenuItems, t, goBackToParentView));
  }

  function renderRenameDropdownSaveSection() {
    return (
      <div className="website-builder-rename-dropdown-save-section">
        <Button
          type="secondary"
          className="rename-dropdown-action"
          onClick={goBackToParentView}
        >
          {t("Cancel")}
        </Button>
        <Button
          type="primary"
          className="rename-dropdown-action"
          onClick={renameDropdown}
          disabled={!renameDropdownEnabled}
        >
          {t("Save")}
        </Button>
      </div>
    );
  }

  return (
    <WebsiteBuilderToolbarMenuView
      title={t("Rename dropdown")}
      goBackToParentView={goBackToParentView}
      footer={renderRenameDropdownSaveSection()}
      sections={[
        {
          content: renderRenameDropdownUpdateSection(),
        },
      ]}
    />
  );
}